import React from 'react';
import { useAuth } from '../context/AuthContext';
import { resolveSalesPageComponent } from './sales/resolveSalesPageView';

/**
 * Entry for /ventas: picks seller vs pos-admin UI from persisted POS role.
 * Authorization and data scope are enforced by the API from the authenticated user role.
 */
const SalesPage = () => {
  const { posRole } = useAuth();
  const View = resolveSalesPageComponent(posRole?.alias);
  return <View />;
};

export default SalesPage;
